export const columnConfig = [
  {
    id: 1,
    name: "Measurement Method",
    label: "measurementMethod",
    enabled: true,
    order: 1,
  },
  { id: 2, name: "Annotations", label: "annotation", enabled: true, order: 2 },
  { id: 3, name: "QR Code", label: "rawQR", enabled: true, order: 3 },
  { id: 4, name: "Batch", label: "batchNumber", enabled: true, order: 4 },
  {
    id: 5,
    name: "Concentration",
    label: "concentration",
    enabled: true,
    order: 5,
  },
  { id: 6, name: "Route", label: "route", enabled: true, order: 6 },
  { id: 7, name: "Device Type", label: "deviceType", enabled: true, order: 7 },
  { id: 8, name: "Site", label: "siteId", enabled: true, order: 8 },
  { id: 9, name: "User", label: "username", enabled: true, order: 9 },
  {
    id: 10,
    name: "Operator ID",
    label: "operatorId",
    enabled: true,
    order: 10,
  },
  {
    id: 11,
    name: "Attachments",
    label: "attachments",
    enabled: true,
    order: 11,
  },
];

export const viewEmptyFilters = {
  period: undefined,
  dates: [],
  routes: [],
  testResult: undefined,
  controlResult: undefined,
  userIds: [],
  customerId: undefined,
  siteId: undefined,
  readerType: undefined,
  measurementMethod: undefined,
};
